<script lang="ts" setup>
import {useEntitiesStore} from "@/stores/entities.store.ts";
import {Source} from "@/domain/type/source.type.ts";
import {ref} from "vue";
import type {AbstractEntity} from "@/domain/entity/AbstractEntity.ts";

const props = defineProps<{
  srcRight: Source,
  entity: AbstractEntity,
}>();

// todo
const store = useEntitiesStore()
const showDialog = ref(false)
const loading = ref(false)

function onClick() {
  loading.value = true
  showDialog.value = false
  store.create(props.entity.uuid).finally(() => {
    loading.value = false
  })
}

function text() {
  let sourceRight = '';
  if (props.srcRight === Source.EVA) {
    sourceRight = 'Eva'
  } else if (props.srcRight === Source.AMMON) {
    sourceRight = 'Ammon'
  }
  return sourceRight
}
</script>

<template>
  <div>
    <v-btn :loading="loading" :text="'Créer dans '+text()" style="width:180px;" @click="showDialog = !showDialog"/>
    <v-dialog v-model="showDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Importer dans {{ text() }}</span>
        </v-card-title>
        <v-card-text>
          {{ entity.getCreateActionText(srcRight) }}
        </v-card-text>
        <v-card-actions>
          <v-btn text="Annuler" @click="showDialog = false"/>
          <v-btn text="Oui" @click="onClick()"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
